<template>
    <el-dialog :visible="visible" width="400px" @close="onClose" class="small-edit-dialog" append-to-body :close-on-click-modal="false">
        <div class="title">{{ title }}</div>
        <div style="margin-bottom: 20px;">
            <el-form :model="form" ref="form" label-position="right" label-width="0" @submit.prevent.native="onSubmitBtnClick()">
                <el-form-item prop="name" :rules="rules.name">
                    <el-input v-model="form.name" :maxlength="20" :placeholder="placeholder" />
                </el-form-item>
            </el-form>
        </div>
        <div class="main-action" style="text-align: right;">
            <el-button type="primary" class="primary-action" @click="onSubmitBtnClick()" :loading="isSubmitting">新增</el-button>
            <el-button @click="onCancelBtnClick(false)">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'SmallTextEditDialog',
    props: {
        visible: {
            Type: Boolean,
            default: false,
        },
        title: {
            Type: String,
            default: '編輯',
        },
        placeholder: {
            Type: String,
            default: '名稱',
        },
        maxlength: {
            Type: Number,
            default: 20,
        },
    },
    watch: {
        visible(newVal) {
            if (newVal === false) {
                this.isSubmitting = false;
            }
        },
    },
    data() {
        return {
            isSubmitting: false,
            form: {
                name: '',
            },
            rules: {
                name: [{ required: true, message: '請輸入', trigger: 'blur' }],
            },
        };
    },
    methods: {
        onCancelBtnClick() {
            this.$emit('close', null);
        },

        onClose() {
            this.$emit('close', null);
        },

        onSubmitBtnClick() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.isSubmitting = true;
                    this.$emit('add-submit', {
                        name: this.form.name,
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
.el-dialog__wrapper.small-edit-dialog {
    .el-dialog {
        padding: 0 30px 30px 30px;
    }
}
</style>
